import { FeatureFlags, FrontendPermissions } from "@vierkant-software/types__api";
import { TreeNode } from "primeng/api";
import { environment } from "src/environments/environment";

export interface gcTreeNode extends TreeNode {
    extraLabel?: "beta" | "newFeature";
    children?: gcTreeNode[];
    permissions?: FrontendPermissions[];
    feature?: FeatureFlags;
    //'yyyy-mm-dd' |true/false
    isBeta?: string | boolean;
    //'yyyy-mm-dd' |true/false
    isNew?: string | boolean;
}

export const menuItems: gcTreeNode[] = [
    {
        icon:  'home',
        label: 'Dashboard',
        data:  ['/'],
    },
    {
        icon:     'sitemap',
        label:    'Organisation',
        children: [
            {
                label:       'Abwesenheit',
                data:        ['/', 'calendar','absence'],
                permissions: [FrontendPermissions.absenceOverview_view],
            },
            {
                label:       'Organigramm',
                extraLabel:  "beta",
                data:        ['/', 'org-chart', 'overview'],
                permissions: [FrontendPermissions.orgCharts_view],
            },
            {
                label:       'Projekte',
                data:        ['/', 'projects-overview'],
                permissions: [FrontendPermissions.projects_view],
            },
            {
                label:       'Schichtplanung',
                extraLabel:  "beta",
                data:        ['/', 'calendar', 'shifts'],
                permissions: [
                    FrontendPermissions.shiftPlaning_view,
                    FrontendPermissions.shiftPlaning_edit,
                    FrontendPermissions.shiftPlan_import,
                    FrontendPermissions.shiftPlan_export
                ],
                feature: FeatureFlags.shift_planning
            },
        ]
    },
    {
        icon:     'play',
        label:    'Check-in',
        children: [
            {
                label:       'MG-Anwesenheit',
                data:        ['/', 'member-check-in'],
                permissions: [FrontendPermissions.memberCheckin_view],
                feature:     FeatureFlags.member_attendance,
            },
            {
                label:       'MA-Anwesenheit',
                data:        ['/', 'attendance-overview'],
                permissions: [FrontendPermissions.attendanceList_view],
            },
            {
                label:       'Zeitkorrektur&shy;anträge',
                data:        ['/', 'time-corrections'],
                permissions: [FrontendPermissions.timeCorrections_edit],
            },
        ]
    },
    {
        icon:        'calendar',
        label:       'Kalender',
        data:        ['/', 'calendar', 'appointments'],
        permissions: [FrontendPermissions.calendar_view],
        feature:     FeatureFlags.calendar,
    },
    {
        icon:     'chart-simple',
        label:    'Auswertungen',
        children: [
            {
                label:       'Abwesenheiten',
                data:        ['/', 'absence-selection'],
                permissions: [FrontendPermissions.absenceStats_view],
                extraLabel:  "beta",
            },
            {
                label:       'Arbeits&shy;zeiten',
                data:        ['/', 'analyses', 'working-time'],
                permissions: [FrontendPermissions.workTimeStats_view],
            },
            {
                label:       'Projekte',
                data:        ['/', 'analyses', 'projects'],
                permissions: [FrontendPermissions.projectStats_view],
            },
            {
                label:       'Berichte',
                data:        ['/', 'analyses', 'reports'],
                permissions: [FrontendPermissions.biReports_view],
                feature:     FeatureFlags.bi_reports,
                extraLabel:  "beta",
            },
            {
                label:       'Stundensätze',
                data:        ['/', 'salaries'],
                // TODO change permission
                permissions: [FrontendPermissions.salaryStats_View],
                extraLabel:  "beta",
            },
        ]
    },
    {
        icon:     'user',
        label:    'Personen',
        children: [
            {
                label:       'Neues Mitglied',
                data:        ['%', 'assign-member-contract', 'assign'],
                permissions: [FrontendPermissions.memberContract_add],
                feature:     FeatureFlags.create_member_contract,
            },
            {
                label:       'Neuer Mitarbeiter',
                data:        ['%', 'contract-employee', 'contract-selection'],
                permissions: [FrontendPermissions.employeeContracts_edit],
            },
            {
                label:       'Neue Person',
                data:        ['%', 'users', 'person'],
                permissions: [FrontendPermissions.person_add],
            },
            {
                label:       'Personen&shy;suche',
                data:        ['/', 'person'],
                permissions: [FrontendPermissions.personSearch_view],
            },
        ]
    },
    {
        icon:     'money-bill-wave',
        label:    'Finanzen',
        children: [
            {
                label:       'Kontoauszüge',
                data:        ['/', 'account-statements'],
                permissions: [FrontendPermissions.accountStatements_View],
                feature:     FeatureFlags.bank_statements,
                children:    [],
            },
            {
                label:       'Lastschriftläufe',
                data:        ['/', 'direct-debit-runs'],
                permissions: [FrontendPermissions.directDebitRun_view],
                feature:     FeatureFlags.create_direct_debit_run,
                children:    [],
            },
        ]
    },
    {
        icon:     'gear',
        label:    'Einstellungen',
        children: [
            {
                label:       'Abläufe',
                data:        ['%', 'workflows', 'general'],
                permissions: [FrontendPermissions.workflowDefaults_edit],
                feature:     FeatureFlags.workflow,
            },
            {
                label:    'Abwesenheiten',
                children: [
                    {
                        label:       'Abwesenheits&shy;typen',
                        data:        ['/', 'absence-types'],
                        permissions: [FrontendPermissions.absenceTypes_view],
                    },
                    {
                        label:       'Übertrag Guthaben',
                        data:        ['/', 'absence-credit-transfer'],
                        permissions: [FrontendPermissions.absenceAccountTransfer_edit],
                    },
                    {
                        label:       'Verfall Guthaben',
                        data:        ['/', 'absence-credit-expiration'],
                        permissions: [FrontendPermissions.absenceAccountExpiry_edit],
                    }
                ]
            },
            {
                label:       'Ansicht',
                data:        ['%', 'company-settings', 'view'],
                permissions: [FrontendPermissions.viewSettings_edit],
            },
            {
                label:       'Auszeiten',
                permissions: [FrontendPermissions.restTimeReasons_view, FrontendPermissions.restTimeSets_view],
                children:    [
                    {
                        label:       'Auszeit-Gründe',
                        data:        ['/', 'rest-time-reasons'],
                        permissions: [FrontendPermissions.restTimeReasons_view]
                    },
                    {
                        label:       'Auszeit-Sets',
                        data:        ['/', 'rest-time-sets'],
                        permissions: [FrontendPermissions.restTimeSets_view]
                    },
                ]
            },
            {
                label:       'Berechtigungsgruppen',
                data:        ['/', 'permission-groups'],
                permissions: [FrontendPermissions.permissionGroups_view],
            },
            {
                label:       'Check-in Bereiche',
                data:        ['/', 'check-in-areas-overview'],
                permissions: [FrontendPermissions.checkInArea_view],
            },
            {
                label:       'DATEV',
                data:        ['/', 'datev'],
                isNew:       '2024-05-19',
                permissions: [FrontendPermissions.datev_edit,FrontendPermissions.datev_hr_eAU],
                feature:     FeatureFlags.datev,
            },
            {
                label:       'Dokumente',
                data:        ['/', 'directory-overview'],
                isNew:       '2024-01-31',
                permissions: [FrontendPermissions.documents_view],
            },
            {
                label:       'Feiertage',
                data:        ['/', 'calendar', "settings", "exceptions"],
                permissions: [FrontendPermissions.holidays_view],
            },
            {
                label:    'Finanzen',
                //TODO: @Chris/Richard: featue/permission on parent menu item is not working
                //permissions: [FrontendPermissions.cashflowSettings_view],
                //feature:     FeatureFlags.memberbox,
                children: [
                    {
                        label:       'Bankkonten',
                        data:        ['/', 'bank-account-overview'],
                        permissions: [FrontendPermissions.cashflowSettings_view],
                        feature:     FeatureFlags.memberbox,
                        children:    [],
                    },
                    {
                        label:       'Buchhaltung',
                        data:        ['%', 'accounting-settings', 'billing', 'billingID'],
                        permissions: [FrontendPermissions.cashflowSettings_view],
                        feature:     FeatureFlags.bookkeeping,
                        children:    [],
                    },
                    {
                        label:       'Buchhaltungskonten',
                        data:        ['/', 'accounting-account-overview'],
                        permissions: [FrontendPermissions.cashflowSettings_view],
                        feature:     FeatureFlags.memberbox,
                        children:    [],
                    },
                    {
                        label:       'EBICS',
                        data:        ['/', 'ebics-contacts-overview'],
                        permissions: [FrontendPermissions.cashflowSettings_view],
                        feature:     FeatureFlags.ebics,
                        children:    [],
                    },
                    {
                        label:       'Lastschriftgruppen',
                        data:        ['/', 'direct-debit-group-overview'],
                        permissions: [FrontendPermissions.cashflowSettings_view],
                        feature:     FeatureFlags.memberbox,
                        children:    [],
                    },
                    {
                        label:       'Mehrwertsteuer',
                        data:        ['/', 'vat-rate-overview'],
                        permissions: [FrontendPermissions.cashflowSettings_view],
                        feature:     FeatureFlags.memberbox,
                        children:    [],
                    },
                ]
            },
            {
                label:    'Firmendaten',
                children: [
                    {
                        label:       'Einstellungen',
                        data:        ['%', 'studio-settings', 'company', 'settings'],
                        permissions: [FrontendPermissions.companySettings_edit],
                    },
                    {
                        label:       'Geschäftszeiten',
                        data:        ['/', 'calendar', "settings-opening-times"],
                        extraLabel:  "newFeature",
                        permissions: [FrontendPermissions.openingTimes_edit],
                    }
                ]
            },
            {
                label:    'Geräte',
                children: [
                    {
                        label:       'Drucker',
                        data:        ['/', 'printers'],
                        permissions: [FrontendPermissions.printer_view],
                    },
                ]
            },
            {
                label:       'Kalender',
                feature:     FeatureFlags.calendar,
                permissions: [FrontendPermissions.calendar_edit],
                children:    [
                    {
                        label:       'Ansichten',
                        data:        ['/', 'calendar', 'settings', 'calendar-presets'],
                        feature:     FeatureFlags.calendar,
                        permissions: [FrontendPermissions.calendar_edit],
                    },
                    {
                        label:       'OTV/Landingpages',
                        data:        ['/', 'self-service'],
                        feature:     FeatureFlags.self_service,
                        permissions: [FrontendPermissions.calendar_edit],
                    },
                    {
                        label:       'Ressourcen',
                        data:        ['/', 'calendar', 'settings', 'resources'],
                        feature:     FeatureFlags.calendar,
                        permissions: [FrontendPermissions.calendar_edit],
                    },
                    {
                        label:       'Terminvorlagen',
                        data:        ['/', 'calendar', 'settings', 'event-templates'],
                        feature:     FeatureFlags.calendar,
                        permissions: [FrontendPermissions.calendar_edit],
                    },
                ],
            },
            {
                label:       'Kasse',
                permissions: [],
                children:    [
                    {
                        label:       'Kassenbereiche',
                        data:        ['/', 'checkout-areas-overview'],
	                      feature:     FeatureFlags.cashbox,
                        permissions: [FrontendPermissions.checkOutAreaRegister_manage],
                    },
                    {
                        label:       'Kassen',
                        data:        ['/', 'cash-registers-overview'],
	                      feature:     FeatureFlags.cashbox,
                        permissions: [FrontendPermissions.checkOutAreaRegister_manage],
                    },
                    {
                        // No cashbox flag (issue #737) - shopping cart groups are also used by GAT Vending.
                        label:       'Warenkorbgruppen',
                        data:        ['/', 'shopping-cart-groups-overview'],
                        permissions: [FrontendPermissions.tseConfiguration_manage],
                    },
                    {
                        label:       'fiskaly API-Key',
                        data:        ['/', 'tse-api-keys-overview'],
                        feature:     FeatureFlags.cashbox,
                        permissions: [FrontendPermissions.tseApiKey_manage],
                    },
                ]
            },
            {
                label:    'MA-Verträge',
                children: [
                    {
                        label:       'Vertrags&shy;vorlagen',
                        data:        ['/', 'employee-contract-template-overview'],
                        permissions: [FrontendPermissions.employeeContractTemplates_view],
                    },
                    {
                        label:       'Zeit&shy;profile',
                        data:        ['/', 'time-tracking'],
                        permissions: [FrontendPermissions.timeTrackingSets_view],
                    },
                    {
                        label:       'Zuschläge',
                        data:        ['/', 'surcharge-overview'],
                        permissions: [FrontendPermissions.surcharge_view],
                    }
                ]
            },
            {
                label:    'MG-Verträge',
                children: [
                    {
                        label:       'Vertragsvorlagen',
                        data:        ['/', 'member-contract-template-overview'],
                        permissions: [FrontendPermissions.memberContractTemplates_view],
                        feature:     FeatureFlags.memberbox,
                    },
                    {
                        label:       'Vertragsdruck',
                        data:        ['%', 'contract-print', 'general'],
                        permissions: [FrontendPermissions.memberContractPrintSettings_edit],
                        feature:     FeatureFlags.memberbox,
                    },
                    {
                        label:       'Kündigungsgründe',
                        data:        ['/', 'cancellation-reasons'],
                        permissions: [FrontendPermissions.customerContractCancelationReasons_view],
                        feature:     FeatureFlags.memberbox,
                    },
                    {
                        label:       'Online-Mitgliedschaft',
                        data:        ['/', 'online-contract-overview'],
                        permissions: [FrontendPermissions.memberContractSelfService_view],
                        feature:     FeatureFlags.memberbox,
                    }
                ]
            },
            {
                // No feature flag - every studio with a cart group needs a number range.
                label:       'Nummernkreise',
                data:        ['/', 'number-ranges-overview'],
                permissions: [FrontendPermissions.numberRange_view],
            },
            {
                label:    'Produktverwaltung',
                children: [
                    {
                        label:       'Produkte',
                        data:        ['/', 'product-management', 'products'],
                        permissions: [FrontendPermissions.product_view],
                    },
                    {
                        label:       'Kategorien',
                        data:        ['/', 'product-categories'],
                        permissions: [FrontendPermissions.product_view],
                    },
                ]
            },
            {
                label:       'Terminals',
                data:        ['/', 'terminals-overview'],
                permissions: [FrontendPermissions.terminals_view],
            },
            {
                label:       'Textdokumente',
                data:        ['/', 'studio-documents'],
                permissions: [FrontendPermissions.createDocuments_view],
            },
            {
                label:       'Zusatzfelder',
                data:        ['%', 'custom-field-config', 'page-1'],
                permissions: [FrontendPermissions.userCustomFields_edit],
            },
            // {
            //     label:       'Terminvorlagen',
            //     data:        ['/', 'calendar', 'settings', 'event-templates'],
            //     permissions: [],
            // },
        ]
    },
    {
        icon:     'screwdriver-wrench',
        label:    'ClusterAdmin',
        children: [
            {
                label:       'Import Users',
                data:        ['/', 'import', 'users'],
                permissions: [FrontendPermissions.ClusterAdmin],
            },
            {
                label:       'Import Contracts',
                data:        ['/', 'import', 'contracts-member'],
                permissions: [FrontendPermissions.ClusterAdmin],
            },
            {
                label:       'Import Credentials',
                data:        ['/', 'import', 'credentials'],
                permissions: [FrontendPermissions.ClusterAdmin],
            },
            {
                label:       'Import User Images',
                data:        ['/', 'import', 'user-images'],
                permissions: [FrontendPermissions.ClusterAdmin],
            },
        ]
    },
];

if (!environment.production) {
    menuItems.push(
        {
            icon:     'screwdriver-wrench',
            label:    'Development',
            children: [
                {
                    label:       'Berechtigungen',
                    data:        ['%', 'member-permissions', 'general'],
                    permissions: [FrontendPermissions.memberPermissions_edit],
                },
                {
                    label:       'Documentation',
                    permissions: [],
                    children:    [
                        {
                            label: 'Usage & Styling',
                            data:  ['/', 'demo', 'documentation', 'usage-styling'],
                        },
                        {
                            label: 'Components',
                            data:  ['/', 'demo', 'documentation', 'components'],
                        },
                    ]
                },
                {
                    label:    'Demo',
                    data:     ['/','demo','test'],
                    children: [
                        {
                            label:    'Test',
                            data:     ['/','demo','test'],
                            children: [],
                        },
                        {
                            label:    'Text',
                            data:     ['/','demo','text'],
                            children: [],
                        },
                        {
                            label:    'Editor',
                            data:     ['/','demo','editor'],
                            children: [],
                        },
                        {
                            label:       'Personensuche',
                            data:        ['/', 'demo', 'search'],
                            permissions: [],
                        },
                        {
                            label:       'ProductSync (Full)',
                            data:        ['/', 'demo', 'product-sync'],
                            permissions: [],
                        },
                        {
                            label:       'Shopping Cart',
                            data:        ['/', 'demo', 'shopping-cart'],
                            permissions: [],
                        },
                    ],
                },
                {
                    label:       'Feiertage',
                    permissions: [],
                    children:    [
                        {
                            label:       'Feiertags-Gebiete',
                            data:        ['/', 'geo-zones'],
                            permissions: []
                        },
                        {
                            label:       'Feiertage',
                            data:        ['/', 'special-days'],
                            permissions: []
                        },
                        {
                            label:       'Geschäftszeiten',
                            data:        ['/', 'settings-opening-times'],
                            permissions: []
                        },
                    ]
                },
                {
                    label:       'Maintenance',
                    data:        ['/','demo','maintenance'],
                    permissions: [],
                },
                {
                    label: 'Wiedervorlage',
                    data:  ['/', 'workflow'],
                }
            ]
        },
    );
}
